export const file2base64 = (file: File) => {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = event => {
      const target = event ? event.target : null;
      if (target) {
        // @ts-ignore
        resolve(target.result);
      } else {
        reject('转换失败');
      }
    };

    reader.readAsDataURL(file);
  });
};

export const randomStr = () => {
  return Math.random()
    .toString(36)
    .slice(-8);
};

// 生成随机字符串
export const buildRandomStr = () => {
  return (
    Math.random()
      .toString()
      .replace('.', '') + Date.now()
  );
};

// 图片尺寸限制
export const maxSize = {
  size: 1 * 1024 * 1024,
  message: '图片最大可上传1M'
};
